import React from "react";
import SeoHead from "../../components/SeoHead";
import MainBanner from "../../components/MainBanner";
import GetInTouch from "../../components/GetInTouch";
import MultiColumnCTAWithDivider from "../../components/MultiColumnCTAWithDivider";
import { Global } from "@sourceflow-uk/sourceflow-sdk";

export default function index({ global }) {
  return (
    <>
      <SeoHead
        page_name={`Global Talent Trends and Insights 2024 | Science, Engineering & Life Science Recruitment, Jobs & Staffing | SRG`}
        canonical_link={`Global Talent Trends and Insights 2024`}
      />
      <MainBanner
        global={global}
        pathPrefix={`salary-survey_page.main_banner`}
        customClass={``}
        content={
          <>
            <h1>Global STEM Talent Trends and Insights 2024</h1>
          </>
        }
        imageURL1={`/site-assets/images/main-banner.jpg`}
        imageALT1={`Main Banner`}
        imageURL2={`/site-assets/images/main-banner-overlay.jpg`}
        imageALT2={`Overlay Main Banner`}
        displayImage1={false}
        editableContent={true}
      />
      <GetInTouch
        global={global}
        pathPrefix={`salary-survey_page.get_in_touch.content`}
        customClass={`py-5`}
        // hubspotForm={'2ad7af1b-ab17-483b-a29a-8ddb48384ba9'}
        successPageUrl={"/site-assets/pdf/SRG_UK_Global_Talent_Trends_Insights_2024.pdf"}
        content={
          <>
            <h2>Refer A Friend</h2>{" "}
            <p>Refer a friend here, please complete the form.</p>
          </>
        }
        dropDownMenu={false}
        showScriptubspotForm={true}
      />
      <MultiColumnCTAWithDivider
        global={global}
        pathPrefix={`salary-survey.multi_column_cta`}
        customClass={`pt-5 pb-md-4 pb-5`}
        left_content={
          <>
              <h3>Need help hiring?</h3>
            <p>
              SRG can partner with you to take your recruitment strategy to the
              next level - our recruitment experts are on hand to help you find
              and retain the right people. Contact us today for an informal
              discussion at 
              <a href="mailto:solutions@srgtalent.com">
                <span>
                  <strong> solutions@srgtalent.com</strong>
                </span>
              </a>
            </p>
          </>
        }
        right_content={
          <>
              <h3>Looking for your next opportunity?</h3>
            <p>
              SRG work with leading global organisations at the helm of
              innovation in STEM. We have job opportunities across the STEM
              industries, covering all experience levels from graduate and entry
              level to executive leadership.
            </p>
          </>
        }
        buttonLink2={`/jobs`}
        buttonTitle2={`Explore our roles here `}
      />
    </>
  );
}

export async function getStaticProps({ params }) {
  const global = (await Global()).toJson();

  return {
    props: {
      global,
    },
  };
}
